import React, { type ReactNode } from 'react';
import Portal from '@atlaskit/portal';
import { Box, xcss } from '@atlaskit/primitives';
import { ff } from '@atlassian/jira-feature-flagging';
import { fullScreenSteps, type Step } from '../../constants/steps';

type Props = {
	children: ReactNode;
	step: Step;
};

export const PortalWrapper = ({ children, step }: Props) => {
	// TODO: remove fullScreenSteps when cleaning standardised flag.
	if (!ff('x2c-jim-home-screen-replacement_eikwe') || !fullScreenSteps.includes(step)) {
		return <>{children}</>;
	}
	return (
		<Portal zIndex={500}>
			<Box
				xcss={portalContentStyles}
				testId="project-create-importer-upload-flow.common.ui.portal-wrapper.portal-wrapper"
			>
				{children}
			</Box>
		</Portal>
	);
};

const portalContentStyles = xcss({
	position: 'fixed',
	top: '0',
	left: '0',
	width: '100vw',
	height: '100vh',
});
